import data from "../../../../../src/ButtonGroup/ButtonGroup.docs.json";
import * as React from 'react';
export default {
  data,
  React
};